'use client';
import { usePathname } from 'next/navigation';
import { useEffect, useMemo, useState } from 'react';

export const usePWA = (): boolean => {
  const [isPwa, setIsPwa] = useState(false);

  useEffect(() => {
    const checkPwa = async () => {
      const isStandalone =
        window.matchMedia('(display-mode: standalone)').matches ||
        (navigator as any).standalone === true;

      let hasServiceWorker = false;
      if ('serviceWorker' in navigator) {
        const registration = await navigator.serviceWorker.getRegistration();
        hasServiceWorker = !!registration;
      }

      setIsPwa(isStandalone && hasServiceWorker);
    };

    checkPwa();
  }, []);

  return isPwa;
};

export const usePwaRouter = () => {
  const pathName = usePathname();

  return useMemo(() => {
    return pathName.startsWith('/pwa');
  }, [pathName]);
};
